interface LookUpEntry {
  isValueAOption?: boolean;
  isSwitch?: boolean;
  isTemp?: boolean;
  isLangBand?: boolean;
}

interface LookUp {
  [key: string]: LookUpEntry;
}

const lookUp: LookUp = {
  deviceOperatingStatus: { isValueAOption: true },
  controlTemperatureSetpoint: { isTemp: true },
  lowControlTemperatureAlarmSetpoint: { isTemp: true },
  highControlTemperatureAlarmSetpoint: { isTemp: true },
  controlBand: { isLangBand: true },
  highTemperatureTripSetpoint: { isTemp: true },
  lowTemperatureAlarmSetpoint: { isTemp: true },
  tsFailModeCoil: { isSwitch: true },
  rtdConfig: { isValueAOption: true },
  outputLimitMode: { isValueAOption: true },
  atcMode: { isValueAOption: true },
  is_celsius: { isValueAOption: true },
  highControlAlarmMask: { isSwitch: true },
  lowControlAlarmMask: { isSwitch: true },
  forcedOn: { isSwitch: true },
  circuitBreakerLimitingAlarmMask: { isSwitch: true },
  switchLimitingAlarmMask: { isSwitch: true },
  outputLimitingAlarmMask: { isSwitch: true },
  lineCurrentTrip: { isSwitch: true },
  switchFailureAlarmMask: { isSwitch: true },
  highLimitCutoutAlarmMask: { isSwitch: true },
  lowLimitCutoutAlarmMask: { isSwitch: true },
  eEROMFailureAlarmMask: { isSwitch: true },
  commFailAlarmMask: { isSwitch: true },
  protectionTripAlarmMask: { isSwitch: true },
  controlTSFailureAlarmMask: { isSwitch: true },
  switchControlMode: { isValueAOption: true },
  remoteOverrideStatus: { isValueAOption: true },
  voltageSource: { isValueAOption: true },
  deadband: { isLangBand: true },
  proportionalBand: { isLangBand: true },
  overrideSourceCoil: { isValueAOption: true },
  externalInputConfig: { isValueAOption: true },
  lowVoltageAlarmMask: { isSwitch: true },
  externalOutputConfig: { isValueAOption: true },
  autoManual: { isValueAOption: true },
  highVoltageAlarmMask: { isSwitch: true },
  powerLimitingAlarmMask: { isSwitch: true },
  lowLoadCurrentAlarmMask: { isSwitch: true },
  controllerResetAlarmMask: { isSwitch: true },
  groundFaultTripAlarmMask: { isSwitch: true },
  highLoadCurrentAlarmMask: { isSwitch: true },
  overcurrentTripAlarmMask: { isSwitch: true },
  temperatureAlarmModeCoil: { isValueAOption: true },
  autocycleIntervalFormatCoil: { isValueAOption: true },
  contactorCycleCountAlarmMask: { isSwitch: true },
  lowTracingResistanceAlarmMask: { isSwitch: true },
  highTracingResistanceAlarmMask: { isSwitch: true },
  highGroundFaultCurrentAlarmMask: { isSwitch: true },
  switchProtectionLimitingAlarmMask: { isSwitch: true },
  highTS1CutoffAlarmMask: { isSwitch: true },
  highTS2CutoffAlarmMask: { isSwitch: true },
  controlMode: { isValueAOption: true },
  highCurrentTripMode: { isSwitch: true },
  highLimitCutoutSetpoint: { isTemp: true },
  highLimitTempEnable: { isSwitch: true },
  highTemperatureTripMode: { isSwitch: true },
  loadCurrentTrip: { isSwitch: true },
  highTemperatureTrip: { isSwitch: true },
  highTemperatureRTD1Trip: { isSwitch: true },
  highTemperatureRTD2Trip: { isSwitch: true },
  gfCurrentTransformerFailureAlarmMask: { isSwitch: true },
  deviceResetAlarmMask: { isSwitch: true },
  digitalInputLocalSrcFailureAlarmMask: { isSwitch: true },
  loadShedSrcFailureAlarmMask: { isSwitch: true },
  loadShedSourceFailureAlarmMask: { isSwitch: true },
  heaterTimeAlarmMask: { isSwitch: true },
  limiterTrippedAlarmMask: { isSwitch: true },
  limiterCommFailureAlarmMask: { isSwitch: true },
  autoCycleEnable: { isSwitch: true },
  safetyLimiterTrippedAlarmMask: { isSwitch: true },
  safetyLimiterTrippedLatching: { isSwitch: true },
  safetyLimiterCommsFailureAlarmMask: { isSwitch: true },
  safetyLimiterTempSensorFailureAlarmMask: { isSwitch: true },
  safetyLimiterTempSensorFailureLatching: { isSwitch: true },
  safetyLimiterConfigLostAlarmMask: { isSwitch: true },
  testGFI: { isSwitch: true },
  contactorActivePolarityUnderSsrControl: { isSwitch: true },
  useDHCP: { isSwitch: true },
  balancedLoad: { isSwitch: true },
  controlTempHighLatching: { isSwitch: true },
  controlTempLowLatching: { isSwitch: true },
  localTempSensorFailLatching: { isSwitch: true },
  localTempSensorHighLatching: { isSwitch: true },
  localTempSensorLowLatching: { isSwitch: true },
  temperatureSource1FailLatching: { isSwitch: true },
  temperatureSource2FailLatching: { isSwitch: true },
  temperatureSource3FailLatching: { isSwitch: true },
  temperatureSource4FailLatching: { isSwitch: true },
  temperatureSource5FailLatching: { isSwitch: true },
  temperatureSource6FailLatching: { isSwitch: true },
  temperatureSource7FailLatching: { isSwitch: true },
  temperatureSource8FailLatching: { isSwitch: true },
  highLoadCurrentLatching: { isSwitch: true },
  highTraceCurrentL1Latching: { isSwitch: true },
  highTraceCurrentL2AlarmMask: { isSwitch: true },
  highTraceCurrentL2Latching: { isSwitch: true },
  highTraceCurrentL3AlarmMask: { isSwitch: true },
  highTraceCurrentL3Latching: { isSwitch: true },
  lowLoadCurrentLatching: { isSwitch: true },
  lowTraceCurrentL1Latching: { isSwitch: true },
  lowTraceCurrentL2AlarmMask: { isSwitch: true },
  lowTraceCurrentL2Latching: { isSwitch: true },
  lowTraceCurrentL3AlarmMask: { isSwitch: true },
  lowTraceCurrentL3Latching: { isSwitch: true },
  highGroundFaultCurrentLatching: { isSwitch: true },
  gfiCurrentTransformerFailureLatching: { isSwitch: true },
  highTracingResistanceLatching: { isSwitch: true },
  lowTracingResistanceLatching: { isSwitch: true },
  highTracingResistanceL1AlarmMask: { isSwitch: true },
  highTracingResistanceL1Latching: { isSwitch: true },
  highTracingResistanceL2AlarmMask: { isSwitch: true },
  highTracingResistanceL2Latching: { isSwitch: true },
  highTracingResistanceL3AlarmMask: { isSwitch: true },
  highTracingResistanceL3Latching: { isSwitch: true },
  lowTracingResistanceL1AlarmMask: { isSwitch: true },
  lowTracingResistanceL1Latching: { isSwitch: true },
  lowTracingResistanceL2AlarmMask: { isSwitch: true },
  lowTracingResistanceL2Latching: { isSwitch: true },
  lowTracingResistanceL3AlarmMask: { isSwitch: true },
  lowTracingResistanceL3Latching: { isSwitch: true },
  switchFailureLatching: { isSwitch: true },
  switchFailureL1AlarmMask: { isSwitch: true },
  switchFailureL2AlarmMask: { isSwitch: true },
  switchFailureL3AlarmMask: { isSwitch: true },
  overcurrentTripL1AlarmMask: { isSwitch: true },
  overcurrentTripL2AlarmMask: { isSwitch: true },
  overcurrentTripL3AlarmMask: { isSwitch: true },
  outputLimitingLatching: { isSwitch: true },
  circuitBreakerLimitingLatching: { isSwitch: true },
  digitalInputLocalRemoteLatching: { isSwitch: true },
  digitalInputLocalSrcFailureLatching: { isSwitch: true },
  loadShedSrcFailureLatching: { isSwitch: true },
  highLimitCutoutLatching: { isSwitch: true },
  lowLimitCutoutLatching: { isSwitch: true },
  switchLimitingLatching: { isSwitch: true },
  limiterTrippedLatching: { isSwitch: true },
  limiterCommFailureLatching: { isSwitch: true },
  controlTempFailureLatching: { isSwitch: true },
  controlTSFailureLatching: { isSwitch: true },
  highVoltageLatching: { isSwitch: true },
  lowVoltageLatching: { isSwitch: true },
  groundFaultCTFailureAlarmMask: { isSwitch: true },
  powerLimitingLatching: { isSwitch: true },
  switchProtectionLimitingLatching: { isSwitch: true },
  externalInputAlarmMask: { isSwitch: true },
  userConfigDataLostAlarmMask: { isSwitch: true },
  userProfile1LostAlarmMask: { isSwitch: true },
  userProfile2LostAlarmMask: { isSwitch: true },
  factoryConfigDataLostAlarmMask: { isSwitch: true },
  maintenanceDataLostAlarmMask: { isSwitch: true },
  temperatureControlMode: { isValueAOption: true },
  failSafeState: { isValueAOption: true },
  temperatureFailMode: { isValueAOption: true },
  autotune: { isSwitch: true },
  latchEnabled: { isSwitch: true },
  tripEnabled: { isSwitch: true },
  'temperatureSensors.1.localTemperatureSensorType': { isValueAOption: true },
  // Gauge types
  GAUGE_CONTROL_TEMPERATURE: { isTemp: true },
  GAUGE_INNER_PANEL_TEMPERATURE: { isTemp: true },
};

// Dynamically add temperature sensor entries with flags
for (let i = 1; i <= 8; i++) {
  lookUp[`temperatureSensors.${i}.lowTemperatureAlarmSetpoint`] = { isTemp: true };
  lookUp[`temperatureSensors.${i}.highTemperatureAlarmSetpoint`] = { isTemp: true };
  lookUp[`temperatureSensors.${i}.mode`] = { isValueAOption: true };
  lookUp[`temperatureSensors.${i}.canAddress`] = { isValueAOption: true };
  lookUp[`temperatureSensors.${i}.config`] = { isValueAOption: true };
  lookUp[`temperatureSensors.${i}.highAlarmFilter`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.highLimitCutoutEnabled`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.lowLimitCutoutEnabled`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.highTemperatureSensorAlarmFilter`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.highTemperatureTripSetpoint`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.leadResistance`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.lowAlarmFilter`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.lowTemperatureSensorAlarmFilter`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.rtdNumber`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.rtdTag`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.type`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.unknown`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.unknown2`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.controlModeEnabled`] = { isSwitch: true };
  lookUp[`temperatureSensors.${i}.temperatureSource${i}FailLatching`] = { isSwitch: true };
  lookUp[`lowTS${i}AlarmMask`] = { isSwitch: true };
  lookUp[`highTS${i}AlarmMask`] = { isSwitch: true };
  lookUp[`ts${i}FailureAlarmMask`] = { isSwitch: true };
  lookUp[`ts${i}FailureLatching`] = { isSwitch: true };
  // Gauge types for temperature sensors
  lookUp[`GAUGE_TEMPERATURE_SENSOR_${i}`] = { isTemp: true };
}

export default lookUp;

/**
 * Check if a key has the isValueAOption flag set
 */
export const isTextValueAOption = (text: string): boolean => {
  const entry = lookUp[text];
  return entry ? Boolean(entry.isValueAOption) : false;
};

/**
 * Check if a key has the isSwitch flag set
 */
export const isTextValueASwitch = (text: string): boolean => {
  const entry = lookUp[text];
  return entry ? Boolean(entry.isSwitch) : false;
};

/**
 * Check if a key has the isTemp flag set
 */
export const isLangATemperature = (text: string): boolean => {
  const entry = lookUp[text];
  return entry ? Boolean(entry.isTemp) : false;
};

/**
 * Check if a key has the isLangBand flag set
 */
export const isLangBand = (text: string): boolean => {
  const entry = lookUp[text];
  return entry ? Boolean(entry.isLangBand) : false;
};

/**
 * Check if a key exists in the lookup
 */
export const hasLookupKey = (text: string): boolean => {
  return text in lookUp;
};
